// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Trader Details – full page with tabs */
.trader-details-page .dashboard-body {
  padding-bottom: 2rem;
}

.trader-details-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  gap: 1rem;
}

.trader-details-hero__badges {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.trader-status-select {
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid;
  cursor: pointer;
  font-family: inherit;
}

.trader-status-select--active {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.trader-status-select--inactive {
  background: #fee2e2;
  color: #b91c1c;
  border-color: #fca5a5;
}

.trader-status-select:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.trader-details-hero__actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}
.cursor-pointer{
  cursor: pointer;
}
.trader-details-hero__avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.7);
  border-radius: var(--radius);
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: #fff;
}

.trader-detail-notfound {
  padding: 2rem;
  color: var(--text-muted);
}

.trader-detail-loading {
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-muted);
}

.trader-detail-loading i {
  margin-right: 0.5rem;
}

.trader-tab-loading,
.trader-tab-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
}

.trader-tab-empty i {
  display: block;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  opacity: 0.5;
}

.trader-tab-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.trader-tab-filter__label {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-muted);
}

.trader-tab-filter__select {
  padding: 0.4rem 0.75rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--text);
}

.trader-tab-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.trader-tab-pagination__info {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.trader-tab-pagination__btns {
  display: flex;
  gap: 0.5rem;
}

.trader-tab-pagination__btn {
  padding: 0.4rem 0.85rem;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #0f766e;
  border-radius: 6px;
  cursor: pointer;
}

.trader-tab-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
}

.trader-tab-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.kyc-timestamps {
  margin: 1rem 0 0;
  font-size: 0.85rem;
  color: var(--text-muted);
}

/* KYC document sections with images */
.kyc-doc-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.kyc-doc-images {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.25rem;
}

.kyc-image-thumb {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid var(--border);
  cursor: pointer;
  transition: border-color 0.2s, transform 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
}

.kyc-image-thumb:hover {
  border-color: #0f766e;
  transform: scale(1.02);
}

.kyc-image-thumb {
  position: relative;
}

.kyc-image-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.kyc-image-thumb__label {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.65);
  color: #fff;
  font-size: 0.65rem;
  padding: 3px 4px;
  text-align: center;
}

/* KYC image zoom overlay */
.kyc-image-zoom {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0,0,0,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.kyc-image-zoom img {
  max-width: 95vw;
  max-height: 95vh;
  object-fit: contain;
  cursor: default;
}

.kyc-image-zoom__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.2);
  color: #fff;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kyc-image-zoom__close:hover {
  background: rgba(255,255,255,0.3);
}

/* KYC document action buttons */
.kyc-doc-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.kyc-doc-actions .btn-sm {
  padding: 0.4rem 0.85rem;
  font-size: 0.85rem;
}

.kyc-doc-actions .btn-primary {
  background: #0f766e;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.kyc-doc-actions .btn-primary:hover:not(:disabled) {
  background: #0d5d56;
}

.kyc-doc-actions .btn-danger {
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.kyc-doc-actions .btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}

.kyc-doc-actions .btn-secondary {
  background: #64748b;
  color: #fff;
}

/* Reject KYC modal */
.kyc-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1001;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.kyc-modal {
  background: var(--card-bg);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 420px;
}

.kyc-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border);
}

.kyc-modal__title {
  margin: 0;
  font-size: 1.1rem;
}

.kyc-modal__close {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: var(--text-muted);
  cursor: pointer;
}

.kyc-modal__body {
  padding: 1.25rem;
}

.kyc-modal__body p {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: var(--text);
}

.kyc-modal__field {
  margin-bottom: 1rem;
}

.text-danger { color: #dc2626; }

.kyc-modal__field label {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
  margin-bottom: 0.35rem;
}

.kyc-modal__field input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 0.9rem;
}

.kyc-reject-reasons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.5rem;
}

.kyc-reject-chip {
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.kyc-reject-chip:hover {
  border-color: #0f766e;
  background: rgba(15, 118, 110, 0.08);
}

.kyc-reject-chip--active {
  border-color: #0f766e;
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
}

.kyc-reject-input {
  margin-top: 0;
}

.kyc-modal__footer {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.kyc-modal__footer .btn-primary {
  background: #0f766e;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.kyc-modal__footer .btn-primary:hover:not(:disabled) {
  background: #0d5d56;
}

.kyc-modal__footer .btn-secondary {
  background: #64748b;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.user-detail-link {
  color: #0f766e;
  text-decoration: none;
}

.user-detail-link:hover {
  text-decoration: underline;
}

/* Tabbed layout */
.trader-details-body {
  padding-top: 0;
}

.trader-details-layout {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 1.5rem;
  align-items: start;
  min-height: 400px;
}

/* Tabs – vertical sidebar */
.trader-details-tabs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 1rem;
}

.trader-details-tabs-section {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.trader-details-tabs-section:not(:first-child) {
  padding-top: 0.5rem;
  border-top: 1px solid #f1f5f9;
}

.trader-details-section-label {
  padding: 0.5rem 1rem 0.25rem;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.trader-details-tab {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.7rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text);
  background: none;
  border: none;
  border-left: 3px solid transparent;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  margin-left: 0;
}

.trader-details-tab i {
  width: 1.1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.trader-details-tab:hover {
  background: #f8fafc;
  color: #0f766e;
}

.trader-details-tab:hover i {
  color: #0f766e;
}

.trader-details-tab--active {
  background: #f0fdfa;
  color: #0f766e;
  border-left-color: #0f766e;
  font-weight: 600;
}

.trader-details-tab--active i {
  color: #0f766e;
}

/* Content area */
.trader-details-content {
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.trader-tab-card {
  padding: 1.5rem;
}

.trader-tab-card__title {
  margin: 0 0 1.25rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text);
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f1f5f9;
}

.trader-tab-card__title i {
  margin-right: 0.5rem;
  color: #0f766e;
  font-size: 0.95rem;
}

/* User Details – modern card layout */
.user-details-card .trader-tab-card__title {
  display: flex;
  align-items: center;
}

.user-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
}

.user-details-group {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid #e2e8f0;
}

.user-details-group__title {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f766e;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-details-group__title i {
  font-size: 0.85rem;
  opacity: 0.9;
}

.user-details-group--full {
  grid-column: 1 / -1;
}

.user-detail-meta {
  margin: 0.5rem 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.user-detail-alert {
  color: #b91c1c;
  font-weight: 600;
}

.detail-table--compact {
  font-size: 0.85rem;
}

.detail-table--compact th,
.detail-table--compact td {
  padding: 0.6rem 0.85rem;
}

.kyc-audit-prev {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.kyc-audit-prev__doc {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.kyc-audit-prev__label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-right: 0.15rem;
}

.kyc-audit-prev .kyc-image-thumb {
  width: 48px;
  height: 48px;
}

.kyc-audit-prev .kyc-image-thumb__label {
  font-size: 0.55rem;
}

.user-details-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.user-detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.user-detail-item__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.user-detail-item__label i {
  margin-right: 0.4rem;
  width: 14px;
  color: #94a3b8;
  font-size: 0.7rem;
}

.user-detail-item__value {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text);
  word-break: break-word;
}

.user-detail-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.88rem;
  color: #0369a1;
}

.user-detail-link {
  color: #0f766e;
  text-decoration: none;
}

.user-detail-link:hover {
  text-decoration: underline;
}

/* KYC Details */
.kyc-details-card .trader-tab-card__title {
  display: flex;
  align-items: center;
}

.referral-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem 2rem;
  margin-bottom: 1.25rem;
  padding: 1rem 1.25rem;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.referral-list-title {
  margin: 1rem 0 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
}

.kyc-status-banner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.kyc-status-banner__actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.kyc-status-banner__actions .btn-sm {
  padding: 0.4rem 0.85rem;
  font-size: 0.85rem;
}

.kyc-status-banner__actions .btn-primary {
  background: #0f766e;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.kyc-status-banner__actions .btn-primary:hover:not(:disabled) {
  background: #0d5d56;
}

.kyc-status-banner__actions .btn-danger {
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.kyc-status-banner__actions .btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}

.kyc-status-banner__hint {
  margin: 0;
  font-size: 0.875rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.kyc-status-banner__hint i {
  color: #0f766e;
  font-size: 0.9rem;
}

.kyc-remark {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.25rem;
  padding: 1rem 1.25rem;
  background: #fffbeb;
  border-radius: 10px;
  border: 1px solid #fde68a;
}

.kyc-remark__icon {
  color: #d97706;
  font-size: 1rem;
  flex-shrink: 0;
}

.kyc-remark__text {
  font-size: 0.9rem;
  color: #92400e;
  line-height: 1.5;
}

/* Definition list */
.detail-dl {
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.85rem 2rem;
}

.detail-dl div {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.detail-dl dt {
  margin: 0;
  min-width: 110px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
}

.detail-dl dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
}

.detail-uuid {
  font-family: ui-monospace, monospace;
  font-size: 0.85rem;
  color: #475569;
}

/* Tables – scrollable after ~10 rows */
.detail-table-wrap {
  overflow: auto;
  max-height: 600px;
  border-radius: 10px;
  border: 1px solid var(--border);
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.detail-table th {
  padding: 0.85rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  background: #f8fafc;
  border-bottom: 2px solid var(--border);
}

.detail-table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #f1f5f9;
}

.detail-table tbody tr:last-child td {
  border-bottom: none;
}

.detail-table tbody tr:hover {
  background: #fafafa;
}

.text-buy { color: #16a34a; font-weight: 500; }
.text-sell { color: #dc2626; font-weight: 500; }

.badge--kyc-0, .badge--kyc-1 { background: #fef3c7; color: #92400e; }
.badge--kyc-2, .badge--kyc-3 { background: #dcfce7; color: #166534; }
.badge--kyc-pending, .badge--kyc-submitted { background: #fef3c7; color: #92400e; }
.badge--kyc-approved { background: #dcfce7; color: #166534; }
.badge--kyc-rejected { background: #fee2e2; color: #b91c1c; }
.badge--completed { background: #dcfce7; color: #166534; }
.badge--buyer, .badge--buy { background: #dbeafe; color: #1e40af; }
.badge--seller, .badge--sell { background: #fce7f3; color: #9d174d; }
.badge--p2p-released, .badge--p2p-paid { background: #dcfce7; color: #166534; }
.badge--p2p-pending-payment { background: #fef3c7; color: #92400e; }
.badge--p2p-cancelled { background: #f1f5f9; color: #64748b; }
.badge--p2p-dispute { background: #fee2e2; color: #b91c1c; }
.badge--danger { background: #fee2e2; color: #b91c1c; }

@media (max-width: 992px) {
  .trader-details-layout {
    grid-template-columns: 1fr;
  }

  .trader-details-tabs {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.5rem;
    position: static;
    border-radius: 12px;
  }

  .trader-details-tab {
    flex: 1 1 auto;
    min-width: 140px;
    border-left: none;
    border-bottom: 3px solid transparent;
    border-radius: 8px;
    margin: 0;
  }

  .trader-details-tab--active {
    border-left: none;
    border-bottom-color: #0f766e;
  }
}

@media (max-width: 576px) {
  .detail-dl {
    grid-template-columns: 1fr;
  }

  .user-details-grid {
    grid-template-columns: 1fr;
  }

  .user-details-group {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Traders/TraderDetailsPage.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,0CAA0C;EAC1C,4BAA4B;EAC5B,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe,cAAc,EAAE;;AAE/B;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,aAAa,cAAc,EAAE,gBAAgB,EAAE;;AAE/C,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,6CAA6C,mBAAmB,EAAE,cAAc,EAAE;AAClF,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,yCAAyC,mBAAmB,EAAE,cAAc,EAAE;AAC9E,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Trader Details – full page with tabs */\n.trader-details-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.trader-details-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* flex-wrap: wrap; */\n  gap: 1rem;\n}\n\n.trader-details-hero__badges {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.trader-status-select {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.trader-status-select--active {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #86efac;\n}\n\n.trader-status-select--inactive {\n  background: #fee2e2;\n  color: #b91c1c;\n  border-color: #fca5a5;\n}\n\n.trader-status-select:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.trader-details-hero__actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n.cursor-pointer{\n  cursor: pointer;\n}\n.trader-details-hero__avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.btn-outline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  background: transparent;\n  color: #fff;\n  border: 2px solid rgba(255, 255, 255, 0.7);\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.btn-outline:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: #fff;\n}\n\n.trader-detail-notfound {\n  padding: 2rem;\n  color: var(--text-muted);\n}\n\n.trader-detail-loading {\n  padding: 3rem 2rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.trader-detail-loading i {\n  margin-right: 0.5rem;\n}\n\n.trader-tab-loading,\n.trader-tab-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.trader-tab-empty i {\n  display: block;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.5;\n}\n\n.trader-tab-filters {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.trader-tab-filter__label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.trader-tab-filter__select {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--card-bg);\n  color: var(--text);\n}\n\n.trader-tab-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.trader-tab-pagination__info {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.trader-tab-pagination__btns {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.trader-tab-pagination__btn {\n  padding: 0.4rem 0.85rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #0f766e;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.trader-tab-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n}\n\n.trader-tab-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.kyc-timestamps {\n  margin: 1rem 0 0;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n/* KYC document sections with images */\n.kyc-doc-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.kyc-doc-images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.kyc-image-thumb {\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 2px solid var(--border);\n  cursor: pointer;\n  transition: border-color 0.2s, transform 0.15s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f8fafc;\n}\n\n.kyc-image-thumb:hover {\n  border-color: #0f766e;\n  transform: scale(1.02);\n}\n\n.kyc-image-thumb {\n  position: relative;\n}\n\n.kyc-image-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.kyc-image-thumb__label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0,0,0,0.65);\n  color: #fff;\n  font-size: 0.65rem;\n  padding: 3px 4px;\n  text-align: center;\n}\n\n/* KYC image zoom overlay */\n.kyc-image-zoom {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0,0,0,0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: zoom-out;\n}\n\n.kyc-image-zoom img {\n  max-width: 95vw;\n  max-height: 95vh;\n  object-fit: contain;\n  cursor: default;\n}\n\n.kyc-image-zoom__close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255,255,255,0.2);\n  color: #fff;\n  cursor: pointer;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kyc-image-zoom__close:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n/* KYC document action buttons */\n.kyc-doc-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.kyc-doc-actions .btn-sm {\n  padding: 0.4rem 0.85rem;\n  font-size: 0.85rem;\n}\n\n.kyc-doc-actions .btn-primary {\n  background: #0f766e;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.kyc-doc-actions .btn-primary:hover:not(:disabled) {\n  background: #0d5d56;\n}\n\n.kyc-doc-actions .btn-danger {\n  background: #dc2626;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.kyc-doc-actions .btn-danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.kyc-doc-actions .btn-secondary {\n  background: #64748b;\n  color: #fff;\n}\n\n/* Reject KYC modal */\n.kyc-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1001;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kyc-modal {\n  background: var(--card-bg);\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.2);\n  width: 90%;\n  max-width: 420px;\n}\n\n.kyc-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.kyc-modal__title {\n  margin: 0;\n  font-size: 1.1rem;\n}\n\n.kyc-modal__close {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: var(--text-muted);\n  cursor: pointer;\n}\n\n.kyc-modal__body {\n  padding: 1.25rem;\n}\n\n.kyc-modal__body p {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.kyc-modal__field {\n  margin-bottom: 1rem;\n}\n\n.text-danger { color: #dc2626; }\n\n.kyc-modal__field label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin-bottom: 0.35rem;\n}\n\n.kyc-modal__field input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.kyc-reject-reasons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-bottom: 0.5rem;\n}\n\n.kyc-reject-chip {\n  padding: 0.35rem 0.65rem;\n  font-size: 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--card-bg);\n  color: var(--text);\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.kyc-reject-chip:hover {\n  border-color: #0f766e;\n  background: rgba(15, 118, 110, 0.08);\n}\n\n.kyc-reject-chip--active {\n  border-color: #0f766e;\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n}\n\n.kyc-reject-input {\n  margin-top: 0;\n}\n\n.kyc-modal__footer {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.kyc-modal__footer .btn-primary {\n  background: #0f766e;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n}\n\n.kyc-modal__footer .btn-primary:hover:not(:disabled) {\n  background: #0d5d56;\n}\n\n.kyc-modal__footer .btn-secondary {\n  background: #64748b;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n}\n\n.user-detail-link {\n  color: #0f766e;\n  text-decoration: none;\n}\n\n.user-detail-link:hover {\n  text-decoration: underline;\n}\n\n/* Tabbed layout */\n.trader-details-body {\n  padding-top: 0;\n}\n\n.trader-details-layout {\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 1.5rem;\n  align-items: start;\n  min-height: 400px;\n}\n\n/* Tabs – vertical sidebar */\n.trader-details-tabs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.5rem 0;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  position: sticky;\n  top: 1rem;\n}\n\n.trader-details-tabs-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.trader-details-tabs-section:not(:first-child) {\n  padding-top: 0.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.trader-details-section-label {\n  padding: 0.5rem 1rem 0.25rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n.trader-details-tab {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.7rem 1rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text);\n  background: none;\n  border: none;\n  border-left: 3px solid transparent;\n  border-radius: 0 8px 8px 0;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  margin-left: 0;\n}\n\n.trader-details-tab i {\n  width: 1.1rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.trader-details-tab:hover {\n  background: #f8fafc;\n  color: #0f766e;\n}\n\n.trader-details-tab:hover i {\n  color: #0f766e;\n}\n\n.trader-details-tab--active {\n  background: #f0fdfa;\n  color: #0f766e;\n  border-left-color: #0f766e;\n  font-weight: 600;\n}\n\n.trader-details-tab--active i {\n  color: #0f766e;\n}\n\n/* Content area */\n.trader-details-content {\n  min-width: 0;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.trader-tab-card {\n  padding: 1.5rem;\n}\n\n.trader-tab-card__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text);\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.trader-tab-card__title i {\n  margin-right: 0.5rem;\n  color: #0f766e;\n  font-size: 0.95rem;\n}\n\n/* User Details – modern card layout */\n.user-details-card .trader-tab-card__title {\n  display: flex;\n  align-items: center;\n}\n\n.user-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.user-details-group {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 1.25rem;\n  border: 1px solid #e2e8f0;\n}\n\n.user-details-group__title {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #0f766e;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.user-details-group__title i {\n  font-size: 0.85rem;\n  opacity: 0.9;\n}\n\n.user-details-group--full {\n  grid-column: 1 / -1;\n}\n\n.user-detail-meta {\n  margin: 0.5rem 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.user-detail-alert {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.detail-table--compact {\n  font-size: 0.85rem;\n}\n\n.detail-table--compact th,\n.detail-table--compact td {\n  padding: 0.6rem 0.85rem;\n}\n\n.kyc-audit-prev {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.kyc-audit-prev__doc {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.kyc-audit-prev__label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-right: 0.15rem;\n}\n\n.kyc-audit-prev .kyc-image-thumb {\n  width: 48px;\n  height: 48px;\n}\n\n.kyc-audit-prev .kyc-image-thumb__label {\n  font-size: 0.55rem;\n}\n\n.user-details-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.user-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.user-detail-item__label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.user-detail-item__label i {\n  margin-right: 0.4rem;\n  width: 14px;\n  color: #94a3b8;\n  font-size: 0.7rem;\n}\n\n.user-detail-item__value {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text);\n  word-break: break-word;\n}\n\n.user-detail-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.88rem;\n  color: #0369a1;\n}\n\n.user-detail-link {\n  color: #0f766e;\n  text-decoration: none;\n}\n\n.user-detail-link:hover {\n  text-decoration: underline;\n}\n\n/* KYC Details */\n.kyc-details-card .trader-tab-card__title {\n  display: flex;\n  align-items: center;\n}\n\n.referral-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem 2rem;\n  margin-bottom: 1.25rem;\n  padding: 1rem 1.25rem;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n}\n\n.referral-list-title {\n  margin: 1rem 0 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.kyc-status-banner {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.25rem;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n}\n\n.kyc-status-banner__actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.kyc-status-banner__actions .btn-sm {\n  padding: 0.4rem 0.85rem;\n  font-size: 0.85rem;\n}\n\n.kyc-status-banner__actions .btn-primary {\n  background: #0f766e;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.kyc-status-banner__actions .btn-primary:hover:not(:disabled) {\n  background: #0d5d56;\n}\n\n.kyc-status-banner__actions .btn-danger {\n  background: #dc2626;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.kyc-status-banner__actions .btn-danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.kyc-status-banner__hint {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.kyc-status-banner__hint i {\n  color: #0f766e;\n  font-size: 0.9rem;\n}\n\n.kyc-remark {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n  padding: 1rem 1.25rem;\n  background: #fffbeb;\n  border-radius: 10px;\n  border: 1px solid #fde68a;\n}\n\n.kyc-remark__icon {\n  color: #d97706;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.kyc-remark__text {\n  font-size: 0.9rem;\n  color: #92400e;\n  line-height: 1.5;\n}\n\n/* Definition list */\n.detail-dl {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 0.85rem 2rem;\n}\n\n.detail-dl div {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n.detail-dl dt {\n  margin: 0;\n  min-width: 110px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.detail-dl dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.detail-uuid {\n  font-family: ui-monospace, monospace;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n/* Tables – scrollable after ~10 rows */\n.detail-table-wrap {\n  overflow: auto;\n  max-height: 600px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n}\n\n.detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.detail-table th {\n  padding: 0.85rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border-bottom: 2px solid var(--border);\n}\n\n.detail-table td {\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.detail-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.detail-table tbody tr:hover {\n  background: #fafafa;\n}\n\n.text-buy { color: #16a34a; font-weight: 500; }\n.text-sell { color: #dc2626; font-weight: 500; }\n\n.badge--kyc-0, .badge--kyc-1 { background: #fef3c7; color: #92400e; }\n.badge--kyc-2, .badge--kyc-3 { background: #dcfce7; color: #166534; }\n.badge--kyc-pending, .badge--kyc-submitted { background: #fef3c7; color: #92400e; }\n.badge--kyc-approved { background: #dcfce7; color: #166534; }\n.badge--kyc-rejected { background: #fee2e2; color: #b91c1c; }\n.badge--completed { background: #dcfce7; color: #166534; }\n.badge--buyer, .badge--buy { background: #dbeafe; color: #1e40af; }\n.badge--seller, .badge--sell { background: #fce7f3; color: #9d174d; }\n.badge--p2p-released, .badge--p2p-paid { background: #dcfce7; color: #166534; }\n.badge--p2p-pending-payment { background: #fef3c7; color: #92400e; }\n.badge--p2p-cancelled { background: #f1f5f9; color: #64748b; }\n.badge--p2p-dispute { background: #fee2e2; color: #b91c1c; }\n.badge--danger { background: #fee2e2; color: #b91c1c; }\n\n@media (max-width: 992px) {\n  .trader-details-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .trader-details-tabs {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 0.5rem;\n    position: static;\n    border-radius: 12px;\n  }\n\n  .trader-details-tab {\n    flex: 1 1 auto;\n    min-width: 140px;\n    border-left: none;\n    border-bottom: 3px solid transparent;\n    border-radius: 8px;\n    margin: 0;\n  }\n\n  .trader-details-tab--active {\n    border-left: none;\n    border-bottom-color: #0f766e;\n  }\n}\n\n@media (max-width: 576px) {\n  .detail-dl {\n    grid-template-columns: 1fr;\n  }\n\n  .user-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .user-details-group {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
